import { CONDITION_OPERATORS, IConditionFieldPreset, IReturnReasonPreset, POLICY_CONDITION_COMPARE_VALUE_TYPE } from "../../policy-types";
import WindowCompareValueStore from "./window-compare-value-store";
import WeightCompareValueStore from "./weight-compare-value-store";
import DateCompareValueStore from "./date-compare-value-store";
import KeyValueCompareValueStore from "./key-value-compare-value-store";
import IntegerBetweenCompareValueStore from "./integer-between-compare-value-store";
import LocationCompareValueStoreList from "./location-compare-value-list-stores/location-compare-value-store-list";
import TagCompareValueStore from "./tag-compare-value-store";
import IntegerCompareValueStore from "./integer-compare-value-store";
import PurchasedCompareValueStore from "./purchased-compare-value-store";
import PriceCompareValueStore from "./price-compare-value-store";
import ReturnReasonCompareValueStore from "./return-reason-compare-value-store";
import StringCompareValueStore from "./string-compare-value-store";
import CustomerStateCompareValueStore from "./customer-state-compare-value-store";
import FloatCompareValueStore from "./float-compare-value-store";
import { ICompareValueTypeComponentProps } from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/condition-field";
import { IChangeable } from "../../../../stores/types";

export interface ICompareValueStore<ICompareValueType> extends IChangeable<string> {
    readonly Component: React.FC<ICompareValueTypeComponentProps>;
    commitChanges: () => void;
    setChanges: (changes?: string) => void;
    discardUncommittedChanges: () => void;
    getUncommittedChanges: () => ICompareValueType;
    onOperatorChanged: (op: CONDITION_OPERATORS) => void;
}

type ICreateCompareValueStore = (fieldPreset: IConditionFieldPreset, returnReasonPresets?: IReturnReasonPreset[], compareValue?: string) => ICompareValueStore<any>;

export const createCompareValueStore: ICreateCompareValueStore = (
    fieldPreset: IConditionFieldPreset,
    returnReasonPresets?: IReturnReasonPreset[],
    compareValue?: string,
) => {
    switch (fieldPreset.compare_value_type) {
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.WINDOW:
            return new WindowCompareValueStore(fieldPreset, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.WEIGHT:
            return new WeightCompareValueStore(fieldPreset, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.DATE:
            return new DateCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.KEY_VALUE:
            return new KeyValueCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.INTEGER_BETWEEN:
            return new IntegerBetweenCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.LOCATION:
            return new LocationCompareValueStoreList(fieldPreset, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.PRICE:
            return new PriceCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.STRING:
            return new StringCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.TAG:
            return new TagCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.INTEGER:
            return new IntegerCompareValueStore(compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.RETURN_REASON:
            return new ReturnReasonCompareValueStore(returnReasonPresets, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.CUSTOMER_STATE:
            return new CustomerStateCompareValueStore(fieldPreset, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.PURCHASED:
            return new PurchasedCompareValueStore(fieldPreset, compareValue);
        case POLICY_CONDITION_COMPARE_VALUE_TYPE.FLOAT:
            return new FloatCompareValueStore(compareValue);
        default:
            throw new Error(`Not implemented compare value type: ${fieldPreset.compare_value_type}`);
    }
}
